(() => {
  // app/scripts/clear-cart-logout.js
  window.addEventListener("load", () => {
    if (!document.referrer)
      return;
    const urlReferrer = new URL(document.referrer)?.href;
    if (urlReferrer?.includes("account.mayway.com")) {
      clearCart();
    }
  });
  var clearCart = async () => {
    try {
      const expireDate = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
      const path = "path=/";
      const cookies = ["cart", "cart_sig", "cart_timestamp"];
      cookies.forEach((name) => {
        document.cookie = `${name}=; ${expireDate}; ${path};`;
      });
      updateCartSections();
    } catch (error) {
      console.error("Error clearing cart:", error);
    }
  };
  var updateCartSections = async () => {
    try {
      const response = await fetch("/?sections=cart-icon-bubble");
      const data = await response.json();
      const cartIconBubble = document.querySelector("#cart-icon-bubble");
      if (data["cart-icon-bubble"] && cartIconBubble) {
        cartIconBubble.innerHTML = data["cart-icon-bubble"];
      }
    } catch (error) {
      console.error("Error updating cart sections:", error);
    }
  };
})();
